export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    
    GET_ENTITLEMENT_REQUEST: 'ENTITLEMENT_REQUEST',
    GET_ENTITLEMENT_SUCCESS: 'ENTITLEMENT_SUCCESS',
    GET_ENTITLEMENT_FAILURE: 'ENTITLEMENT_FAILURE',
   
    
    LOGOUT: 'USERS_LOGOUT',

    CS2_SPECS_DOWNLOAD: 'CS2_SPECS_DOWNLOAD',
    
    DB_CS2_SPECS: 'DB_CS2_SPECS',
    
    DB_DMMEC_ADMIN: 'DB_DMMEC_ADMIN',
    DB_DMMEC_USERS: 'DB_DMMEC_USERS',
    
    DB_NEW_RULE134_ADMIN: 'DB_New_Rule134Admin',
    DB_NEW_RULE134_USERS: 'DB_New_Rule134Users',
    
    DB_WEB_CS2PLUS_USERS: 'DB_WEB_CS2PLUS_USERS',
    	
    DB_CS2PLUS_USERS_LEGACY: 'DB_CS2PlusUsers',

    CS2_SPECS_DOWNLOAD_SUCCESS: 'CS2_SPECS_DOWNLOAD_SUCCESS',
    CS2_SPECS_DOWNLOAD_FAILURE: 'CS2_SPECS_DOWNLOAD_FAILURE',

    CHANGE_PASSWORD_REQUEST: 'CHANGE_PASSWORD_REQUEST',
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE',
    
    GET_VERSION_REQUEST: 'GET_VERSION_REQUEST',
    GET_VERSION_SUCCESS: 'GET_VERSION_SUCCESS',
    GET_VERSION_FAILURE: 'GET_VERSION_FAILURE' 

};
